import React from 'react';
import { Paper, Stack, Typography, Chip, Tooltip, Divider, Tabs, Tab } from '@mui/material';

const EventHeader = ({ event, tab = 'teams', onTabChange, showCharts = true }) => {
    const handleChange = (_e, value) => {
        onTabChange?.(value);
    };

    return (
        <Paper
            elevation={0}
            sx={{
                px: 2, py: 1.5,
                border: 1, borderColor: 'divider',
                bgcolor: 'background.paper',
                maxWidth: '100%',
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={1}
                sx={{ gap: 2, flexWrap: 'wrap' }}
            >
                <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
                    <Chip
                        label={`Event #${event.number}`}
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{ fontWeight: 600 }}
                    />
                    <Tooltip title={event.name || ''} disableInteractive>
                        <Typography variant="h6" sx={{ m: 0, minWidth: 0 }} noWrap>
                            {event.name}
                        </Typography>
                    </Tooltip>
                </Stack>

                <Stack direction="row" spacing={1} alignItems="center">
                    {event.company && (
                        <Chip
                            label={`Company: ${event.company}`}
                            size="small"
                            variant="outlined"
                            color="warning"
                            sx={{ maxWidth: '100%' }}
                        />
                    )}

                    <Tabs
                        value={tab}
                        onChange={handleChange}
                        aria-label="Event views"
                        sx={{
                            minHeight: 36,
                            '& .MuiTab-root': { minHeight: 36, px: 1.5 },
                        }}
                    >
                        <Tab value="teams" label="Teams" />
                        {showCharts && <Tab value="charts" label="Charts" /> }
                    </Tabs>
                </Stack>
            </Stack>

            <Divider sx={{ my: 1 }} />

            {event.fullTitle && (
                <Tooltip title={event.fullTitle} disableInteractive>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        noWrap
                        sx={{ minWidth: 0 }}
                    >
                        {event.fullTitle}
                    </Typography>
                </Tooltip>
            )}
        </Paper>
    );
};

export default EventHeader;
